type ServiceVisualType = "platform" | "observability";

export function ServiceVisual({ type }: { type: ServiceVisualType }) {
  return (
    <div className={`service-visual service-visual-${type}`} aria-hidden="true">
      <div className="visual-grid" />

      {type === "platform" && (
        <svg className="vector-illustration architecture-vector" viewBox="0 0 420 320" focusable="false">
          {/* A system built in layers: connectivity, runtime, applications and data. */}
          <path className="architecture-guide" d="M34 80V54h26M360 54h26v26M34 252v26h26M360 278h26v-26" />

          <g className="architecture-foundation">
            <path className="architecture-side" d="m52 205 158 79v12L52 217z" />
            <path className="architecture-side-dark" d="m210 284 158-79v12l-158 79z" />
            <path className="architecture-surface" d="m52 205 158-79 158 79-158 79z" />
            <path className="architecture-trace" d="m105 210 53 27 52-26 52 26 53-27M210 211v49" />
            <path className="architecture-node" d="m96 210 9-5 9 5-9 5zm105 50 9-5 9 5-9 5zm105-50 9-5 9 5-9 5z" />
          </g>

          <path className="architecture-support" d="M80 154v47M340 154v47M210 219v22" />

          <g className="architecture-runtime">
            <path className="architecture-side" d="m80 143 130 65v12L80 155z" />
            <path className="architecture-side-dark" d="m210 208 130-65v12l-130 65z" />
            <path className="architecture-surface" d="m80 143 130-65 130 65-130 65z" />
            <path className="architecture-trace" d="m160 145 50 25 60-30M210 170v19" />
          </g>

          <g className="architecture-application">
            <path className="architecture-side" d="m114 107 39 20v37l-39-20z" />
            <path className="architecture-side-dark" d="m153 127 39-20v37l-39 20z" />
            <path className="architecture-module-top" d="m114 107 39-20 39 20-39 20z" />
            <path className="architecture-code" d="m127 121-6 4 6 10m11-9 6 10-6 4" />
            <path className="architecture-detail" d="m163 136 19-10m-19 18 12-6" />
          </g>

          <g className="architecture-data">
            <path className="architecture-side" d="M237 85v39c0 16 54 16 54 0V85z" />
            <path className="architecture-detail" d="M237 98c0 16 54 16 54 0m-54 13c0 16 54 16 54 0" />
            <ellipse className="architecture-module-top" cx="264" cy="85" rx="27" ry="12" />
          </g>

          <g className="architecture-container">
            <path className="architecture-side" d="m179 145 31 16v22l-31-16z" />
            <path className="architecture-side-dark" d="m210 161 31-16v22l-31 16z" />
            <path className="architecture-module-top" d="m179 145 31-16 31 16-31 16z" />
            <path className="architecture-detail" d="M188 156v9m8-5v9m23-2 13-7" />
          </g>
        </svg>
      )}

      {type === "observability" && (
        <svg className="vector-illustration troubleshooting-vector" viewBox="0 0 420 320" focusable="false">
          {/* The system in context, with one trace brought into focus. */}
          <path className="troubleshooting-guide" d="M34 80V54h26M360 54h26v26M34 252v26h26M360 278h26v-26" />

          <g className="troubleshooting-system">
            <path className="troubleshooting-side" d="m52 211 158 79v11L52 222z" />
            <path className="troubleshooting-side-dark" d="m210 290 158-79v11l-158 79z" />
            <path className="troubleshooting-surface" d="m52 211 158-79 158 79-158 79z" />
            <path className="troubleshooting-route" d="m96 210 58 29 56-28 56 28 58-29M210 211v55M116 157v32m171-40v40" />
            <path className="troubleshooting-node" d="m88 210 8-4 8 4-8 4zm228 0 8-4 8 4-8 4z" />
          </g>

          <g className="troubleshooting-application">
            <path className="troubleshooting-side" d="m84 111 36 18v35l-36-18z" />
            <path className="troubleshooting-side-dark" d="m120 129 36-18v35l-36 18z" />
            <path className="troubleshooting-module-top" d="m84 111 36-18 36 18-36 18z" />
            <path className="troubleshooting-detail" d="m94 127 17 9m-17 0 17 9m18-7 17-8m-17 18 10-5" />
          </g>

          <g className="troubleshooting-database">
            <path className="troubleshooting-side" d="M263 91v37c0 15 48 15 48 0V91z" />
            <path className="troubleshooting-detail" d="M263 103c0 15 48 15 48 0m-48 13c0 15 48 15 48 0" />
            <ellipse className="troubleshooting-module-top" cx="287" cy="91" rx="24" ry="11" />
          </g>

          <path className="troubleshooting-signal" d="M168 87h16l6-8 8 17 7-9h23" />

          <g className="troubleshooting-lens">
            <path className="troubleshooting-handle-border" d="m247 211 47 47" />
            <path className="troubleshooting-handle" d="m247 211 47 47" />
            <circle cx="209" cy="173" r="54" />
            <path className="troubleshooting-trace-guide" d="M180 147v22h12v23h12" />
            <path className="troubleshooting-trace" d="M180 147h42m-17 45h28" />
            <rect className="troubleshooting-trace-focus" x="191" y="164" width="48" height="10" rx="3" />
          </g>
        </svg>
      )}
    </div>
  );
}
